module.exports = __webpack_public_path__ + "static/media/spain.2ca29748.svg";